// Single place that turns entity data into a public URL. Precedence:
//   1. vanityPath   (full current path from the API, e.g. /therapy-group/x)
//   2. prefix + vanitySlug (mirror column + type)
//   3. /group/<publicId>  (uuid alias, 308s to the vanity path when one exists)
//   4. /group/<id>        (legacy integer id, 308s too)
// Every site link should go through one of these so that a slug change never
// leaves stale links behind.

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import {
  groupTypePrefix,
  PROVIDER_PREFIX,
  ORGANIZATION_PREFIX,
} from "./groupTypePrefix"

// Canonical / JSON-LD / sitemap URLs deliberately use the production origin
// (the existing pages hard-coded it the same way), so a staging render never
// declares itself canonical.
export const PUBLIC_SITE_ORIGIN = "https://getzestlife.com"

type Idish = string | number | null | undefined

export type GroupPathInput = {
  type?: unknown
  vanitySlug?: string | null
  vanityPath?: string | null
  publicId?: string | null
  id?: Idish
}

export type ProviderPathInput = {
  vanitySlug?: string | null
  vanityPath?: string | null
  publicId?: string | null
  id?: Idish
}

export type OrganizationPathInput = {
  vanitySlug?: string | null
  vanityPath?: string | null
  id?: string | null
}

const clean = (v: unknown): string | null =>
  typeof v === "string" && v.trim() ? v.trim() : null

const isPath = (v: unknown): v is string =>
  typeof v === "string" && v.startsWith("/") && !v.startsWith("//")

export function buildGroupPath(input: GroupPathInput): string | null {
  if (isPath(input?.vanityPath)) return input.vanityPath
  const prefix = groupTypePrefix(input?.type)
  const slug = clean(input?.vanitySlug)
  if (prefix && slug) return `/${prefix}/${slug}`
  const publicId = clean(input?.publicId)
  if (publicId) return `/group/${publicId}`
  if (input?.id !== null && input?.id !== undefined && `${input.id}`.trim()) {
    return `/group/${encodeURIComponent(String(input.id))}`
  }
  return null
}

export function buildProviderPath(input: ProviderPathInput): string | null {
  if (isPath(input?.vanityPath)) return input.vanityPath
  const slug = clean(input?.vanitySlug)
  if (slug) return `/${PROVIDER_PREFIX}/${slug}`
  const publicId = clean(input?.publicId)
  if (publicId) return `/group-leader/${publicId}`
  if (input?.id !== null && input?.id !== undefined && `${input.id}`.trim()) {
    return `/group-leader/${encodeURIComponent(String(input.id))}`
  }
  return null
}

export function buildOrganizationPath(input: OrganizationPathInput): string | null {
  if (isPath(input?.vanityPath)) return input.vanityPath
  const slug = clean(input?.vanitySlug)
  if (slug) return `/${ORGANIZATION_PREFIX}/${slug}`
  const id = clean(input?.id)
  if (id) return `/${ORGANIZATION_PREFIX}/${id}`
  return null
}

export function buildAbsoluteUrl(path: string | null | undefined): string | null {
  if (!isPath(path)) return null
  return `${PUBLIC_SITE_ORIGIN}${path}`
}

/** Site-relative -> absolute using the running app's own origin (share links). */
export function buildAppUrl(path: string | null | undefined): string | null {
  if (!isPath(path)) return null
  const origin = (process.env.NEXT_PUBLIC_APP_URL || PUBLIC_SITE_ORIGIN).replace(
    /\/$/,
    "",
  )
  return `${origin}${path}`
}
